var map = {
	"./cosmetic-dentistry.svg": "798a",
	"./dental-technician-working@2x.png": "8e2c",
	"./dentures-and-prosthodontics.svg": "bc6b",
	"./endodontic-therapy.svg": "99cf",
	"./oral-hygiene.svg": "df48",
	"./oral-surgery-and-implantology.svg": "716e",
	"./test.png": "0385",
	"./tooth-restorations.svg": "5edf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70ad";